import { SESSION_TIMEOUT } from '../../types/constants'
import { longIdle } from '../env'

export default (() => {
    let sessionTimer: any

    const handleSessionTimeout = () =>{
        console.log("Session time out at " + (new Date()).toLocaleTimeString())
        longIdle(performance.now())
    }

    const reset = () => {
        clearTimeout(sessionTimer)
        sessionTimer = setTimeout(handleSessionTimeout, SESSION_TIMEOUT)
    }

    return ({
        reset
    })
})()